import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAX2NSw6_yb7_bApFQlpGagz5A5QsuXcKI",
  authDomain: "ai-powered-company.firebaseapp.com",
  projectId: "ai-powered-company",
  storageBucket: "ai-powered-company.firebasestorage.app",
  messagingSenderId: "142582771740",
  appId: "1:142582771740:web:4a15460f52d512b5696fd9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;
